import adminDineSavvyWatermark from './admin/bottom.png';
import adminSidebarLogo from './admin/dinesavvysidebar.svg';
import adminLogo from './admin/logo.png';
import businessuserLogo from './businessuser/logo.svg';
import merchantDashboardLogo from './merchant/dashboard-logo.svg';
import merchantDineSavvyLogoCompact from './merchant/dine-savvy-logo-compact.svg';
import merchantDineSavvyLogo from './merchant/dine-savvy-logo.svg';
import merchantFavicon from './merchant/favicon.svg';
import merchantLogo from './merchant/logo.svg';
import merchantQrCenterLogo from './merchant/ic_qr_center_logo.png';

export const portalLogos = {
  admin: adminLogo,
  businessuser: businessuserLogo,
  merchant: merchantLogo,
};

export const getPortalLogo = (portalType) => portalLogos[portalType] || portalLogos.admin;

export const getMerchantDineSavvyLogo = () => merchantDineSavvyLogo;

/** Oversized decorative wordmark bled off the admin login screen edges. Placeholder — replace with the real asset. */
export const getAdminAuthWatermark = () => adminDineSavvyWatermark;

/** Compact wordmark shown at the top of the admin sidebar. */
export const getAdminSidebarLogo = () => adminSidebarLogo;

export const getMerchantDineSavvyLogoCompact = () =>
  merchantDineSavvyLogoCompact || merchantDineSavvyLogo;

/** Wide DINE Savvy lockup for merchant dashboard header (Figma: 539×44). */
export const getMerchantDineSavvyLogoHeader = () => merchantDashboardLogo;

export const getMerchantDashboardLogo = () => merchantDashboardLogo;

export const getMerchantFavicon = () => merchantFavicon;

/** DINE Savvy wordmark overlaid in the center of business QR codes. */
export const getMerchantQrCenterLogo = () => merchantQrCenterLogo;

export { adminLogo, merchantDineSavvyLogo, merchantFavicon };
